export default __webpack_public_path__ + "static/media/r4.6a3ff23c.jpeg";